import { Services, empty } from '@sigma-frontend-libs/commons'

import { icons, proxy, validation } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }), validation ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isNew: Boolean
  },

  data() {
    return {
      visibility: {
        password: true,
        token: true,
        apikey: true
      }
    }
  },

  computed: {
    recordsValidation() {
      return Object.values(this.proxy.records).some(Boolean)
    },

    validation() {
      return !!this.proxy.title && this.recordsValidation
    }
  },

  methods: {
    getRecordFieldAutocomplete(field) {
      switch (field) {
        case 'username': return 'username'
        case 'password': return 'new-password'
        case 'token':
        case 'apikey':
        default: return 'off'
      }
    },

    getRecordFieldRequired(field) {
      return !!this.proxy.records[field] || !this.recordsValidation
    },

    getSecretFieldIcon(field) {
      if (this.visibility[field]) {
        return icons.visibility
      }

      return icons.visibility_off
    },

    getSecretFieldType(field) {
      if (this.visibility[field]) {
        return 'password'
      }

      return 'text'
    },

    toggleSecretFieldVisibility(field) {
      this.visibility[field] = !this.visibility[field]
    },

    getRecordFieldProps(field) {
      return {
        value: this.proxy.records[field],
        label: this.getTranslate(`${Services.credentials}.labels.records.${field}`),
        autocomplete: this.getRecordFieldAutocomplete(field),
        required: this.getRecordFieldRequired(field),
        defaultValue: empty?.credentials?.create?.records?.[field] || '',
        dense: true,
        rounded: true,
        clearable: true,
        details: false
      }
    },

    getSecretFieldProps(field) {
      return {
        ...this.getRecordFieldProps(field),
        type: this.getSecretFieldType(field),
        afterIcon: this.getSecretFieldIcon(field),
        afterIconCallback: () => {
          return this.toggleSecretFieldVisibility(field)
        }
      }
    },

    setRecordValue(field, value) {
      this.proxy.records[field] = value
    },

    setTitle(value) {
      this.proxy.title = value
    }
  },

  render
}
